import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useGetMonthName } from 'helpers/hooks'
import { Icons } from 'helpers/icons'
import { formatDate } from 'utils/stories'

interface ScheduledInfoBubbleProps {
    date: Date
    removeSchedule: () => void
    customClass?: string
    noText?: boolean
}

export const ScheduledInfoBubble = ({
    date,
    removeSchedule,
    customClass = '',
    noText = false
}: ScheduledInfoBubbleProps) => {
    const { t } = useTranslation()
    const dateName = useGetMonthName()

    return (
        <ScheduledInfoContainer className={customClass}>
            {!noText && (
                <ScheduledText>
                    {t('scheduledFor')}
                </ScheduledText>
            )}

            <DateSpan>
                {formatDate(date, dateName.getMonthName)}
            </DateSpan>

<RemoveButton
    onClick={removeSchedule}
    aria-label={t('removeDate')}
>
    <RemoveIcon>×</RemoveIcon>
</RemoveButton>
        </ScheduledInfoContainer>
    )
}

const ScheduledInfoContainer = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.2rem;
    line-height: 1.5rem;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 20px;
    color: #828c94;
    padding: 0.6rem 1.1rem;
    margin-bottom: 1rem;

    display: flex;
    align-items: center;
`

const ScheduledText = styled.span`
    margin-right: 0.3rem;
`

const DateSpan = styled.span`
    color: #2894ff;
`

const RemoveButton = styled.button`
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    min-height: 2rem;

    border: none;
    border-radius: 50%;
    background: #ffffff;

    display: grid;
    place-items: center;

    cursor: pointer;
    padding: 0;
    flex-shrink: 0;

    margin-left: 0.5rem;
`

const RemoveIcon = styled.span`
    color: #acacac;
    font-size: 2rem;
    line-height: 1;
    font-weight: 300;

    display: block;

    transform: translateY(-0.0rem);
`